import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface UploadIdentityResponse {
  success: boolean;
  message: string;
  data: {
    uuid: string;
    country: string;
    keys: {
      selfie: string;
      documentFront: string;
      documentBack: string | null;
    };
  };
}

@Injectable({ providedIn: 'root' })
export class IdentityUploadService {
  private baseUrl = environment.apiNest;

  constructor(private http: HttpClient) {}

  /**
   * Sube imágenes de identidad a S3
   * @param uuid - cognitoId del usuario
   * @param country - 'CL' para Chile, 'VE' para Venezuela
   * @param selfie - Archivo de selfie
   * @param documentFront - Archivo foto frontal del documento
   * @param documentBack - Archivo foto trasera (solo Chile)
   */
  async uploadIdentityDocuments(
    uuid: string,
    country: 'CL' | 'VE',
    selfie: File,
    documentFront: File,
    documentBack?: File
  ): Promise<UploadIdentityResponse> {
    const url = `${this.baseUrl}public/person-registration/upload-documents`;

    const formData = new FormData();
    formData.append('uuid', uuid);
    formData.append('country', country);
    formData.append('includeBack', country === 'CL' ? 'true' : 'false');
    formData.append('selfie', selfie);
    formData.append('documentFront', documentFront);

    if (country === 'CL' && documentBack) {
      formData.append('documentBack', documentBack);
    }

    // Sin `skip`: se manda el JWT de la sesión. El back exige que el `uuid` sea
    // el cognitoId del usuario logueado (antes cualquiera subía a nombre de otro, A7).
    const headers = new HttpHeaders({});

    try {
      const response = await firstValueFrom(
        this.http.post<UploadIdentityResponse>(url, formData, { headers })
      );
      return response;
    } catch (error: any) {
      throw {
        message: 'Error al subir imágenes',
        detail: error?.error?.message || error?.message || 'Error desconocido',
        statusCode: error?.status || 500,
      };
    }
  }
}
